import { Link } from "react-router-dom";
import { Button, Form } from "antd";
import ControlledInputBox from "../../components/ControlledInputBox";

/* const styles = {
  loginFormContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  loginForm: {
    display: "flex",
    flexDirection: "column",
    width: 400,
    border: "2px solid #f3f4f5",
    padding: 30,
    paddingTop: 20,
    borderRadius: 4,
  },
  heading: {
    fontFamily: "'B612', open-sans",
    fontSize: 32,
    marginBottom: 15,
    color: "#0a8080",
  },
}; */

const ResetPasswordForm = ({ onSubmit, loading, control, errors }) => {
  return (
    <div className="loginFormContainer">
      <Form colon={false}>
        <div className="loginForm">
          <div
            style={{ borderBottom: "2px dashed #f3f4f5", marginBottom: "15px" }}
          >
            <p className="heading">Reset Password</p>
          </div>
          <ControlledInputBox
            type="password"
            required
            control={control}
            errors={errors}
            name="password"
            placeholder="Super secret password"
            label="New Password"
          />
          <ControlledInputBox
            type="password"
            required
            control={control}
            errors={errors}
            name="passwordConfirm"
            placeholder="One more time"
            label="Confirm Password"
          />
          <Button
            type="primary"
            size="large"
            disabled={loading}
            loading={loading}
            onClick={onSubmit}
          >
            Reset Password
          </Button>
          <div style={{ padding: "20px 0 0 0", textAlign: "center" }}>
            <Link to="/">Login</Link>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
